(() => {
  'use strict';

  const TEXT_REPLACEMENTS = [
    ['Her story gerçek bir ürüne, güncel fiyata ve mağazada yayınlanan gerçek müşteri yorumlarına bağlıdır.', 'Her story güncel bir ürüne, güncel fiyata ve mağazada yayınlanmış müşteri yorumlarına bağlıdır.'],
    ['SİPARİŞTE 2 ÜCRETSİZ NUMUNE', 'TÜM SİPARİŞLERDE ÜCRETSİZ KARGO'],
    ['Siparişlerde 2 ücretsiz numune', 'Tüm siparişlerde ücretsiz kargo'],
    ['MAĞAZA ZİYARETÇİSİ YORUMU', 'YAYINLANMIŞ MÜŞTERİ YORUMU'],
    ['Gerçek müşteri yorumları', 'Yayınlanmış müşteri yorumları'],
    ['gerçek müşteri yorumları', 'yayınlanmış müşteri yorumları'],
    ['GERÇEK SATIN ALIM', 'SATIN ALIM'],
    ['gerçek satın alım', 'satın alım'],
    ['GERÇEK RUTİNLER', 'RİTÜEL GÖRÜNTÜLERİ'],
    ['GERÇEK FİYAT', 'GÜNCEL FİYAT'],
    ['GERÇEK YORUM', 'YAYINLANMIŞ YORUM'],
    ['gerçek yorum', 'yayınlanmış yorum'],
    ['Gerçek dokuyu izle.', 'Ürün dokusunu izle.'],
    ['Gerçek doku', 'Ürün dokusu'],
    ['GERÇEK RİTÜEL', 'RİTÜEL'],
    ['Gerçek hammadde', 'Hammadde niteliği'],
    ['Gerçek formül', 'Formül uyumu'],
    ['Gerçek ritüel', 'Ritüel yaklaşımı'],
    ['3D GÜVENLİ ÖDEME', 'GÜVENLİ ÖDEME'],
    ['2 ÜCRETSİZ NUMUNE', 'ÜCRETSİZ KARGO']
  ];

  const ARIA_REPLACEMENTS = [
    ['gerçek yorumu oku', 'yayınlanmış yorumu oku'],
    ['Gerçek müşteri yorumları', 'Yayınlanmış müşteri yorumları']
  ];

  const replaceAll = (value, replacements) => replacements.reduce(
    (result, [from, to]) => result.includes(from) ? result.replaceAll(from, to) : result,
    String(value || '')
  );

  const isAllowedTextNode = node => {
    const parent = node.parentElement;
    if (!parent) return false;
    return !['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'OPTION'].includes(parent.tagName);
  };

  const patchTextNode = node => {
    if (!node || node.nodeType !== Node.TEXT_NODE || !isAllowedTextNode(node)) return;
    const next = replaceAll(node.nodeValue, TEXT_REPLACEMENTS);
    if (next !== node.nodeValue) node.nodeValue = next;
  };

  const patchText = root => {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) {
      patchTextNode(root);
      return;
    }
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) patchTextNode(node);
  };

  const patchAriaElement = element => {
    if (!element?.getAttribute) return;
    const label = element.getAttribute('aria-label');
    if (!label) return;
    const next = replaceAll(label, ARIA_REPLACEMENTS);
    if (next !== label) element.setAttribute('aria-label', next);
  };

  const patchAria = root => {
    if (!root || root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;
    if (root.nodeType === Node.ELEMENT_NODE) patchAriaElement(root);
    root.querySelectorAll?.('[aria-label]').forEach(patchAriaElement);
  };

  const patch = root => {
    patchText(root);
    patchAria(root);
  };

  const init = () => {
    patch(document);
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'characterData') patchTextNode(mutation.target);
        if (mutation.type === 'attributes') patchAriaElement(mutation.target);
        mutation.addedNodes?.forEach(patch);
      });
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['aria-label']
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();